"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MarkerIcon;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function MarkerIcon() {
  return _react2.default.createElement("svg", {
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": true
  }, _react2.default.createElement("defs", null), _react2.default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react2.default.createElement("g", {
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, _react2.default.createElement("path", {
    d: "M5.383375,15.6771875 C0.8428125,9.09471875 0,8.41915625 0,6 C0,2.68628125 2.68628125,0 6,0 C9.31371875,0 12,2.68628125 12,6 C12,8.41915625 11.1571875,9.09471875 6.616625,15.6771875 C6.31865625,16.107625 5.6813125,16.1075937 5.383375,15.6771875 Z M6,8.5 C7.38071875,8.5 8.5,7.38071875 8.5,6 C8.5,4.61928125 7.38071875,3.5 6,3.5 C4.61928125,3.5 3.5,4.61928125 3.5,6 C3.5,7.38071875 4.61928125,8.5 6,8.5 Z"
  }))));
}